import React from 'react';
import { Link } from 'react-router-dom';

const HomePage = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen  w-full bg-gray-100">
      <h1 className="text-5xl font-bold mb-6 text-gray-900">Welcome to Learn JavaScript</h1>
      <p className="text-xl text-gray-700 mb-6">Start your journey to mastering JavaScript, one of the most popular programming languages in the world.</p>
      <Link to="/articles" className="bg-blue-500 text-white px-6 py-3 rounded-md hover:bg-blue-600 text-lg font-medium">
        Start Learning
      </Link>
    </div>
  );
};

export default HomePage;
